import { COLORS, FONTS } from './designTokens';

export const METHODIK_CARD_BORDER = 'rgba(93, 93, 93, 0.30)';

/** Desktop-Karten — etwas kleiner, damit 3 Spalten ins 1373px-Raster passen */
export const OVERVIEW_CARD_MD_WIDTH = 306;
export const OVERVIEW_CARD_MD_HEIGHT = 250;

export const METHODIK_CARD_PADDING = {
  xs: '20px 20px 16px 20px',
  md: '16px 28px 14px 16px',
} as const;

export const methodikCardSx = {
  display: 'flex',
  width: { xs: '100%', md: OVERVIEW_CARD_MD_WIDTH },
  maxWidth: { xs: '100%', md: OVERVIEW_CARD_MD_WIDTH },
  height: { xs: 'auto', md: OVERVIEW_CARD_MD_HEIGHT },
  minHeight: { xs: 252, md: OVERVIEW_CARD_MD_HEIGHT },
  padding: METHODIK_CARD_PADDING,
  flexDirection: 'column',
  justifyContent: 'flex-start',
  alignItems: 'stretch',
  gap: '10px',
  border: `1px solid ${METHODIK_CARD_BORDER}`,
  borderRadius: 0,
  backgroundColor: COLORS.bgWhite,
  flexShrink: 0,
  overflow: 'hidden',
  boxSizing: 'border-box',
  boxShadow: '0 0 0 rgba(57, 57, 57, 0)',
  transform: 'translateY(0)',
  transition:
    'border-color 0.55s ease-in-out, background-color 0.55s ease-in-out, box-shadow 0.55s ease-in-out, transform 0.55s ease-in-out',
  '& .MuiTypography-root': {
    width: '100%',
    maxWidth: '100%',
    transition: 'color 0.55s ease-in-out',
  },
  '&:hover': {
    border: `1px solid ${COLORS.bg}`,
    background: COLORS.bg,
    boxShadow: '0 10px 28px rgba(57, 57, 57, 0.14)',
    transform: 'translateY(-3px)',
    '& .MuiTypography-root': {
      color: COLORS.textOnDark,
    },
  },
} as const;

export const methodikCardTitleSx = {
  fontFamily: FONTS.sans,
  fontWeight: 500,
  fontSize: '18px',
  lineHeight: '24px',
  color: COLORS.textMutedOnLight,
} as const;

export const methodikCardBodySx = {
  fontFamily: FONTS.sans,
  fontWeight: 300,
  fontSize: '14px',
  lineHeight: 1.5,
  color: '#393939',
} as const;

export const methodikCardClickableSx = {
  ...methodikCardSx,
  cursor: 'pointer',
  textAlign: 'left' as const,
  textDecoration: 'none',
  color: 'inherit',
  outline: 'none',
  '&:focus-visible': {
    outline: `2px solid ${COLORS.bg}`,
    outlineOffset: 2,
  },
} as const;

const ENTWICKLUNGEN_CARD_LINE = COLORS.text;
const ENTWICKLUNGEN_CARD_BORDER = '#909090';
const ENTWICKLUNGEN_CARD_BODY_COLOR = '#2D2C2B';

/** Aktuelle Entwicklungen — Headline oben, Text unten */
export const entwicklungenCardTitleSx = {
  ...methodikCardTitleSx,
  color: ENTWICKLUNGEN_CARD_LINE,
} as const;

export const entwicklungenCardBodySx = {
  ...methodikCardBodySx,
  marginTop: 'auto',
  color: ENTWICKLUNGEN_CARD_BODY_COLOR,
} as const;

export const entwicklungenCardSx = {
  ...methodikCardClickableSx,
  backgroundColor: 'transparent',
  border: `1px solid ${ENTWICKLUNGEN_CARD_BORDER}`,
  scrollSnapAlign: 'start',
  cursor: 'default',
  '& .MuiTypography-root': {
    width: '100%',
    maxWidth: '100%',
  },
  '&:hover': {
    border: `1px solid ${ENTWICKLUNGEN_CARD_BORDER}`,
    background: 'transparent',
    boxShadow: 'none',
    transform: 'none',
  },
} as const;

export const ENTWICKLUNGEN_CARD_GAP = 15;
/** Sichtbarer Ausschnitt der nächsten Karte auf Mobile */
export const ENTWICKLUNGEN_MOBILE_PEEK = 56;
export const ENTWICKLUNGEN_CAROUSEL_STEP =
  OVERVIEW_CARD_MD_WIDTH + ENTWICKLUNGEN_CARD_GAP;
